import ThemeExtractor from "../../core/components/ThemeExtractor";
import Paragraphs from "../../pages/website/Paragraphs";
import { OnlineInvitationSiteDetails } from "../../resources/modelTypes";
import { css } from "@emotion/react";
import { LargeHeadline } from "@minted/fancyclothes";
import { styleUtils, theme } from "@minted/minted-components";
import React, { memo } from "react";

const displaySiteDetailsStyles = {
  centered: css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing.x4};
    margin-bottom: ${styleUtils.rem(40)};
    margin-left: auto;
    margin-right: auto;
    max-width: ${styleUtils.rem(780)};
    padding-left: ${theme.spacing.x4};
    padding-right: ${theme.spacing.x4};
    text-align: center;
  `,
  fullWidth: css`
    align-self: center;
    width: 15%;
  `,
  hr: (fontColor: string) => css`
    border-bottom: none;
    border-color: ${fontColor};
    border-left: none;
    border-right: none;
    border-top: ${styleUtils.rem(1)} solid ${fontColor};
  `,
};

export type DisplaySiteDetailsProps = {
  siteDetails: OnlineInvitationSiteDetails;
};

const DisplaySiteDetails = ({ siteDetails }: DisplaySiteDetailsProps) => {
  return (
    <ThemeExtractor rules={["fontColor"]}>
      {({ fontColor }) => (
        <div css={displaySiteDetailsStyles.centered}>
          <LargeHeadline>{siteDetails.eventHeading || ""}</LargeHeadline>
          <div css={displaySiteDetailsStyles.fullWidth}>
            <hr css={displaySiteDetailsStyles.hr(fontColor)} />
          </div>
          <Paragraphs
            text={siteDetails.eventDescription || ""}
            textAlignment="center"
          />
        </div>
      )}
    </ThemeExtractor>
  );
};

const MemoizedDisplaySiteDetails = memo(DisplaySiteDetails);

export { MemoizedDisplaySiteDetails as DisplaySiteDetails };
